import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "auction-info__status" }
const _hoisted_2 = { class: "mt-4" }
const _hoisted_3 = {
  key: 0,
  class: "cancelled-banner"
}
const _hoisted_4 = {
  key: 1,
  class: "completed-banner"
}
const _hoisted_5 = {
  key: 2,
  class: "paused-banner"
}

import AppAssetStatus from '@/components/App/AppAssetStatus.vue';
import AppCardInfo from '@/components/App/AppCardInfo.vue';
import AppAssetProgress from '@/components/App/AppAssetProgress.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';
import { IAsset } from '@/types/store';
import AppAssetTimer from '@/components/App/AppAssetTimer.vue';
import { RAW_ASSETS_STATUSES } from '@/constants/statuses';

// #constants

export default /*@__PURE__*/_defineComponent({
  __name: 'BidViewAuctionInfo',
  setup(__props) {

const { getters } = useStore();

// #computed
const asset = computed<IAsset>(() => {
  return getters['getAsset'];
});
const getStatus = computed<string>(() => {
  const { status } = asset.value ?? {};
  return status;
});
const getEndDate = computed<string>(() => {
  const { auction } = asset.value ?? {};
  const { endDate = '' } = auction ?? {};
  return endDate;
});
const isAuctionCancelled = computed<boolean>(() => {
  return getStatus.value === RAW_ASSETS_STATUSES.CANCELLED;
});
const isAuctionCompleted = computed<boolean>(() => {
  return getStatus.value === RAW_ASSETS_STATUSES.COMPLETED;
});
const isPaused = computed<boolean>(() => {
  // Don't show paused if auction is cancelled or completed
  if (isAuctionCancelled.value || isAuctionCompleted.value) {
    return false;
  }
  const { auction } = asset.value ?? {};
  return !!(auction as any)?.isPaused;
});
const isLiveAuction = computed<boolean>(() => {
  return RAW_ASSETS_STATUSES.LIVE_AUCTION === getStatus.value;
});
const getEndTitle = computed<string>(() => {
  return isLiveAuction.value
    ? 'Live-auction ends in:'
    : 'Offer submission ends in:';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppCardInfo, {
    "card-title": "Offer Details",
    class: "auction-info"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createTextVNode(" Status: ", -1)),
        _createVNode(AppAssetStatus, {
          status: getStatus.value,
          class: "ml-2"
        }, null, 8, ["status"]),
        _renderSlot(_ctx.$slots, "biddersTable"),
        (!isPaused.value && !isAuctionCancelled.value && !isAuctionCompleted.value)
          ? (_openBlock(), _createBlock(AppAssetProgress, {
              key: 0,
              class: "mt-10"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          (isAuctionCancelled.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "cancelled-banner__icon" }, "✕", -1),
                _createElementVNode("div", { class: "cancelled-banner__content" }, [
                  _createElementVNode("div", { class: "cancelled-banner__title" }, "Auction Cancelled"),
                  _createElementVNode("div", { class: "cancelled-banner__subtitle" }, " This auction has been cancelled. Bidding is no longer available. ")
                ], -1)
              ]))]))
            : (isAuctionCompleted.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("div", { class: "completed-banner__icon" }, "✓", -1),
                  _createElementVNode("div", { class: "completed-banner__content" }, [
                    _createElementVNode("div", { class: "completed-banner__title" }, "Auction Completed"),
                    _createElementVNode("div", { class: "completed-banner__subtitle" }, " This auction has ended. Bidding is no longer available. ")
                  ], -1)
                ]))]))
              : (isPaused.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("div", { class: "paused-banner__icon" }, "⏸️", -1),
                    _createElementVNode("div", { class: "paused-banner__content" }, [
                      _createElementVNode("div", { class: "paused-banner__title" }, "Auction Paused"),
                      _createElementVNode("div", { class: "paused-banner__subtitle" }, " Bidding is temporarily suspended ")
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true),
          (!isAuctionCancelled.value && !isAuctionCompleted.value && !isPaused.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("span", null, _toDisplayString(getEndTitle.value), 1),
                _createVNode(AppAssetTimer, {
                  "end-date": getEndDate.value,
                  class: "auction-info__timer"
                }, null, 8, ["end-date"])
              ], 64))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 3
  }))
}
}

})